import { FC } from "react";
import React, { useState } from "react";
import {
  Input,
  Button,
  Form,
  message,
  Flex,
  Card,
  Modal,
  Checkbox,
} from "antd";
import { deleteTeamMember } from "../../../network/teamMember";
import { useMutation } from "@tanstack/react-query";
import { TeamMemberType } from "../../../types/teamMember";
import DeleteModal from "../../common/DeleteModal";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { queryKeys } from "../../../services/react-query/queryKeys";
import { deleteWorkingShift } from "../../../network/workingHours";

interface DeleteWorkingShiftProps {
  teamMemberId: number;
  locationId: number;
  visible: boolean;
  onClose: () => void;
  workingShiftId: any;
}

const DeleteWorkingShift: FC<DeleteWorkingShiftProps> = ({
  visible,
  onClose,
  workingShiftId,
  locationId,
  teamMemberId,
}) => {
  return (
    <DeleteModal
      visible={visible}
      onClose={onClose}
      onDelete={deleteWorkingShift}
      data={{ workingShiftId, teamMemberId, locationId }}
      confirmationHeader="هل انت متأكد من حذف الفترة؟"
      confirmationText=""
      queryKey={queryKeys.workingHours}
      successMessage="Working Shift deleted successfully"
    />
  );
};

export default DeleteWorkingShift;
